import { db } from "../config";
import { doc, setDoc, getDoc, Timestamp } from "firebase/firestore";

export const signUpForProPlanNotify = async (userId, email, billingCycle) => {
  try {
    if (!userId || !email) {
      return { success: false, error: "User ID and email are required" };
    }

    const notifyRef = doc(db, "proPlanNotifications", userId);
    const existingDoc = await getDoc(notifyRef);

    if (existingDoc.exists()) {
      return { success: true, alreadySignedUp: true };
    }

    const notifyData = {
      userId,
      email,
      billingCycle: billingCycle || "monthly",
      createdAt: Timestamp.now(),
      notified: false,
    };

    await setDoc(notifyRef, notifyData);

    return { success: true, alreadySignedUp: false };
  } catch (error) {
    console.error("Error signing up for Pro Plan notify:", error);
    return { success: false, error: error.message };
  }
};

export const checkProPlanNotifyStatus = async (userId) => {
  try {
    if (!userId) {
      return { success: false, alreadySignedUp: false };
    }

    const notifyRef = doc(db, "proPlanNotifications", userId);
    const docSnap = await getDoc(notifyRef);

    return {
      success: true,
      alreadySignedUp: docSnap.exists()
    };
  } catch (error) {
    console.error("Error checking Pro Plan notify status:", error);
    return { success: false, alreadySignedUp: false, error: error.message };
  }
};
